import { createApp } from 'vue';
import scrollToElement from 'scroll-to-element';
import WhyArtosAccordion from './components/WhyArtosAccordion.vue'
import VideoTestimonialsSlider from './components/VideoTestimonialsSlider.vue'
import MarqueeSlider from './components/MarqueeSlider.vue'
import ProductGallery from './components/ProductGallery.vue'
import BreadAnimation from './components/BreadAnimation.vue'
import SearchPopup from './components/SearchPopup.vue'
import ScrollReveal from 'scrollreveal';
import VideoAnimatedSection from './components/VideoAnimatedSection.vue'
import SoftwareExamples from './components/SoftwareExamples.vue'
import StickyProductTitle from './components/StickyProductTitle.vue'

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

if(isTouchDevice()) {
    document.documentElement.classList.add('touch');
}

const app = createApp({
    components: {
      WhyArtosAccordion,
      VideoTestimonialsSlider,
      MarqueeSlider,
      ProductGallery,
      BreadAnimation,
      SearchPopup,
      VideoAnimatedSection,
      SoftwareExamples,
      StickyProductTitle
    },

    data() {
        return {
            showMobileMenu: false
        }
    },
    
    mounted() {
        // Add sticky header functionality
        const header = document.querySelector('header');
        let lastScrollTop = 0;
        
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            if (scrollTop > 50) {
                header.classList.add('is-sticky');
            } else {
                header.classList.remove('is-sticky');
            }
            
            lastScrollTop = scrollTop;
        };
        
        window.addEventListener('scroll', handleScroll);
        
        // Add scroll arrow functionality
        const scrollArrow = document.querySelector('.scroll-arrow');
        if (scrollArrow) {
            scrollArrow.addEventListener('click', () => {
                const nextSection = document.querySelector('.home-welcome').nextElementSibling;
                if (nextSection) {
                    scrollToElement(nextSection, {
                        duration: 1000,
                        ease: 'inOutCube',
                        offset: -80
                    });
                }
            });
        }
        
        let revealOptions = {
            viewOffset: {
                top: 60,
                bottom: 100
            },
            reset: false,
            easing: 'cubic-bezier(0.5, 0, 0, 1)',
            mobile: true
        };

        let slideUp = {
            distance: '30px', 
            origin: 'bottom', 
            duration: 1000, 
            delay: 100, 
            ...revealOptions
        }

        let slideUpDelayed = {
            distance: '30px', 
            origin: 'bottom', 
            duration: 1000, 
            delay: 200, 
            ...revealOptions
        }
        
        let slideLeft = {
            distance: '50px',
            origin: 'left',
            duration: 1000,
            delay: 200,
            ...revealOptions
        }
        
        let slideRight = {
            distance: '50px',
            origin: 'right',
            duration: 1000,
            delay: 200,
            ...revealOptions
        }
        
        let fadeIn = {
            opacity: 0,
            duration: 1200,
            delay: 200,
            ...revealOptions
        }
        
        let scaleUp = {
            scale: 0.85,
            opacity: 0,
            duration: 1000,
            delay: 200,
            ...revealOptions
        }
        
        let staggered = {
            distance: '30px',
            origin: 'bottom',
            duration: 800,
            delay: 100,
            interval: 100,
            ...revealOptions
        }
        
        ScrollReveal().reveal('.slide-up', slideUp);
        ScrollReveal().reveal('.slide-up-delayed', slideUpDelayed);
        ScrollReveal().reveal('.slide-left', slideLeft);
        ScrollReveal().reveal('.slide-right', slideRight);
        ScrollReveal().reveal('.fade-in', fadeIn);
        ScrollReveal().reveal('.scale-up', scaleUp);
        ScrollReveal().reveal('.staggered-item', staggered);
    },

    methods: {
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
            document.querySelector('.header__burger').classList.toggle('is-active');
            document.body.style.overflow = this.showMobileMenu ? 'hidden' : '';
        },
        scrollTo(e) {
            scrollToElement(e.target.hash, {
                duration: 1600,
                ease: 'inOutCube',
                offset: -120
            });
        },
    
    }
});


const vm = app.mount("#site");

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}



